<template>
	<v-menu offset-y>
		<template #activator="{ on }">
			<v-btn icon v-on="on">
				<v-icon class="font-size-grande material-icons">mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list class="pa-1">
			<v-list-item-group>
				<v-list-item
					v-if="deveExibirAcaoConcluirEdicao"
					class="list-item-height"
					data-testid="action-convite"
					@click="$emit('concluir-edicao-documento')"
					v-az-auth="permissoes.pedidoUtilizacaoDocumentoEditorTextoSincronizar"
				>
					<v-list-item-icon>
						<tooltip-informacao
							mensagem="Existe um termo de desentranhamento em elaboração para este documento.
										Clique na ação para acessar as etapas da elaboração."
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-account-plus</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Concluir Edição</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item
					data-testid="action-convite"
					@click="tratarEventoConvidarSignatarios"
					v-if="exibirAcaoConvidarSignatarios()"
					v-az-auth="permissoes.pedidoUtilizacaoDocumentoConvidarSignatarios"
				>
					<v-list-item-icon>
						<tooltip-informacao
							mensagem="Existe um termo de desentranhamento em elaboração para este documento.
										Clique na ação para acessar as etapas da elaboração."
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-account-plus</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Convite</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item
					data-testid="action-enviar-fornecedor"
					@click="tratarEventoEnviarFornecedor"
					v-if="podeEnviarFornecedor()"
					v-az-auth="permissoes.pedidoUtilizacaoDocumentoEnviarFornecedor"
				>
					<v-list-item-icon>
						<v-icon :size="tamanhoIconeMenu" class="material-icons">mdi-send</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Enviar Fornecedor</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-divider v-if="exibirAcaoConvidarSignatarios"></v-divider>
				<v-list-item
					v-if="exibirAcaoDesentranhar()"
					class="list-item-height"
					@click="verificarRedigirTermoDesentranhamento"
					v-az-auth="permissoes.pedidoUtilizacaoProcessoDigitalTermoDesentranhamentoCriar"
				>
					<v-list-item-icon>
						<tooltip-informacao
							:mensagem="getMensagemTooltip()"
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon v-else class="material-icons" :size="tamanhoIconeMenu">mdi-close</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Desentranhar</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					class="list-item-height"
					data-testid="action-cancelar"
					v-if="exibirAcaoCancelar()"
					v-az-auth="permissoes.pedidoUtilizacaoDocumentoProcessoDigitalCancelar"
					@click="$emit('cancelar')"
				>
					<v-list-item-icon>
						<tooltip-informacao
							:mensagem="getMensagemTooltip()"
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon v-else :size="tamanhoIconeMenu" class="material-icons mr-2"
							>mdi-close-circle-outline
						</v-icon>
					</v-list-item-icon>

					<v-list-item-title class="texto-menu-interno">Cancelar</v-list-item-title>
				</v-list-item>

				<v-list-item
					class="list-item-height"
					data-testid="action-baixar"
					v-if="exibirAcaoBaixar()"
					v-az-auth="permissoes.pedidoUtilizacaoDocumentoBaixar"
					@click="$emit('baixar')"
				>
					<v-list-item-icon>
						<tooltip-informacao
							mensagem="Existe um termo de desentranhamento em elaboração para este documento.
										Clique na ação para acessar as etapas da elaboração."
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" class="material-icons" v-else>mdi-download</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Baixar</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					v-if="
						isEditar &&
						!documentoOuAnexoEstaJuntado(documentoOuAnexo) &&
						!documentoOuAnexoEstaJuntadoDesatualizado(documentoOuAnexo) &&
						!isAtaCancelada
					"
					class="list-item-height"
					data-testid="action-excluir"
					@click="$emit('excluir')"
					v-az-auth="permissoes.pedidoUtilizacaoDocumentoExcluir"
				>
					<v-list-item-icon>
						<tooltip-informacao
							:mensagem="getMensagemTooltip()"
							:tamanho-icone="tamanhoIconeMenu"
							v-if="possuiTermoDesentranhamento() || isDocumentoEnviadoEdocs()"
							class="mr-2"
							color="primary"
						></tooltip-informacao>
						<v-icon :size="tamanhoIconeMenu" v-else class="material-icons">mdi-delete</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title class="texto-menu-interno">Excluir</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>
</template>
<script>
import documentoMixin from '@/views/mixins/documento'
import { opcaoSimNao, situacoes, situacoesEdocs } from '@/core/constants'
import TipoDocumentoRegistro from '@/core/constants/tipo-documento-registro'
import TooltipInformacao from '@/views/components/TooltipInformacao.vue'
import { mapState } from 'vuex'

export default {
	name: 'acessar-pedido-documentos-itens-btn-acoes',
	components: { TooltipInformacao },
	mixins: [documentoMixin],
	inject: ['isEditar'],
	props: {
		documentoOuAnexo: {
			type: Object,
			default: () => null,
		},
	},
	emits: ['tratar-evento-desentranhar', 'convidar-signatarios', 'enviar-fornecedor'],
	data() {
		return {
			tamanhoIconeMenu: '18px',
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
			tipoRegistroDocumento: TipoDocumentoRegistro,
		}
	},
	computed: {
		...mapState({
			infoPedido: (state) => state.pedido.informacoesPedido,
		}),
		deveExibirAcaoConcluirEdicao() {
			return (
				this.isDocumento(this.documentoOuAnexo) &&
				this.documentoEstaCriado(this.documentoOuAnexo) &&
				!this.isAtaCancelada
			)
		},
		isAtaCancelada() {
			return this.infoPedido.ataRegistroPreco?.situacao === situacoes.ATA.CANCELADO.value
		},
	},
	methods: {
		tratarEventoConvidarSignatarios() {
			this.$emit('convidar-signatarios')
		},
		tratarEventoEnviarFornecedor() {
			this.$emit('enviar-fornecedor')
		},
		exibirAcaoConvidarSignatarios() {
			return (
				!this.ehTermoDeDesentranhamento() &&
				this.ehDocumentoEmRascunho() &&
				this.isProcessoDigitalAtivo &&
				!this.isAtaCancelada
			)
		},
		verificarRedigirTermoDesentranhamento() {
			this.$emit('tratar-evento-desentranhar')
		},
		exibirAcaoDesentranhar() {
			return !this.ehTermoDeDesentranhamento() && this.ehDocumentoJuntado()
		},
		ehDocumentoEmRascunho() {
			return this.documentoOuAnexo.situacao === situacoes.DOCUMENTO.RASCUNHO.value
		},
		ehDocumentoJuntado() {
			return this.documentoOuAnexo.situacao === situacoes.DOCUMENTO.JUNTADO.value
		},
		ehDocumentoDesatualizado() {
			return this.documentoOuAnexo.situacao === situacoes.DOCUMENTO.DESATUALIZADO.value
		},
		ehDocumentoJuntadoDesatualizado() {
			return this.documentoOuAnexo.situacao === situacoes.DOCUMENTO.JUNTADO_DESATUALIZADO.value
		},
		possuiTermoDesentranhamento() {
			return opcaoSimNao.SIM.value === this.documentoOuAnexo.possuiTermoDesentranhamento
		},
		podeEnviarFornecedor() {
			return this.documentoOuAnexo.podeEnviarFornecedor && !this.isAtaCancelada
		},
		ehTermoDeDesentranhamento() {
			return opcaoSimNao.SIM.value === this.documentoOuAnexo.ehTermoDesentranhamento
		},
		exibirAcaoCancelar() {
			return (
				!this.ehTermoDeDesentranhamento() &&
				(this.ehDocumentoJuntado() || this.ehDocumentoJuntadoDesatualizado())
			)
		},
		exibirAcaoBaixar() {
			return !this.ehDocumentoJuntadoDesatualizado() && !this.ehDocumentoDesatualizado()
		},
		isDocumentoEnviadoEdocs() {
			return (
				situacoesEdocs.AGUARDANDO.value === this.documentoOuAnexo.situacaoEdocs ||
				situacoesEdocs.SINCRONIZADO.value === this.documentoOuAnexo.situacaoEdocs
			)
		},
		getMensagemTooltip() {
			if (this.isDocumentoEnviadoEdocs()) {
				return 'Não é possível realizar essa ação, pois o documento já foi ou está sendo enviado ao e-Docs.'
			}

			return 'Existe um termo de desentranhamento em elaboração para este documento. Clique na ação para acessar as etapas da elaboração.'
		},
	},
}
</script>
<style scoped lang="stylus">
.font-size-grande
	font-size 28px !important

.texto-menu-interno
	font-size 0.8em

.list-item-height
	min-height 0 !important

.v-list-item
	padding 0 5px !important

.v-list-item__icon
	margin auto 5px !important

.v-list-item--disabled
	cursor not-allowed !important
</style>
